export default "__VITE_ASSET__616c88ba__"